import React from 'react'
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import PopInRightPanel from '../components/PopInRightPanel';
import CustomerTable from '../components/CustomerTable';
import OpportunityTable from '../components/OpportunityTable';

function Recommendations() {
  return (
    <>
    <main className="main-content border-radius-lg ">
    <NavBar/>   
    <CustomerTable/>
    <OpportunityTable/>
    <Footer/>
    </main>
    <PopInRightPanel/>
    </>
  )
}

export default Recommendations
